// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GrantItem } from './grant-item';
import {
    GrantItemFromJSON,
    GrantItemFromJSONTyped,
    GrantItemToJSON,
    GrantItemToJSONTyped,
} from './grant-item';

/**
 * 
 * @export
 * @interface GrantListResponse
 */
export interface GrantListResponse {
    /**
     * Whether the caller may grant and revoke access on this resource. A caller who only reads the study sees the list read-only
     * @type {boolean}
     * @memberof GrantListResponse
     */
    can_manage: boolean;
    /**
     * 
     * @type {Array<GrantItem>}
     * @memberof GrantListResponse
     */
    items: Array<GrantItem>;
    /**
     * 
     * @type {string}
     * @memberof GrantListResponse
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the GrantListResponse interface.
 */
export function instanceOfGrantListResponse(value: object): value is GrantListResponse {
    if (!('can_manage' in value) || value['can_manage'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GrantListResponseFromJSON(json: any): GrantListResponse {
    return GrantListResponseFromJSONTyped(json, false);
}

export function GrantListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'can_manage': json['can_manage'],
        'items': ((json['items'] as Array<any>).map(GrantItemFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function GrantListResponseToJSON(json: any): GrantListResponse {
    return GrantListResponseToJSONTyped(json, false);
}

export function GrantListResponseToJSONTyped(value?: GrantListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'can_manage': value['can_manage'],
        'items': ((value['items'] as Array<any>).map(GrantItemToJSON)),
        'nextToken': value['nextToken'],
    };
}
